import React from "react";
import { Input as AntInput } from "antd";
import cx from "classnames";
import { InputProps } from "./types";

export class Input extends React.PureComponent<InputProps> {
  private readonly _inputRef = React.createRef<AntInput>();
  public state = {
    currentValue: this.props.value || this.props.defaultValue || "",
  };

  public static getDerivedStateFromProps(props: InputProps, state: any) {
    if (props.value !== undefined && props.value !== state.currentValue) {
      return {
        currentValue: props.value,
      };
    }
    return null;
  }

  public setValue(value: string): void {
    if (this._inputRef.current) {
      this._inputRef.current.input.value = value;
      this.setState({ currentValue: value });
    }
  }

  public select(): void {
    if (this._inputRef.current) {
      this._inputRef.current.select();
    }
  }

  private readonly handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ currentValue: e.target.value });
    if (this.props.onChange) {
      this.props.onChange(e);
    }
  };

  public render() {
    const {
      className,
      shape = "round",
      showCount,
      maxLength,
      suffix,
      onChange,
      value,
      defaultValue,
      ...rest
    } = this.props;
    const { currentValue } = this.state;

    const inputClassName = cx(this.props.className, "gm-input", {
      [`gm-input-${shape}`]: shape,
    });

    const input = (
      <AntInput
        {...rest}
        ref={this._inputRef}
        className={inputClassName}
        maxLength={maxLength}
        suffix={suffix}
        onChange={this.handleChange}
        value={value}
        defaultValue={defaultValue}
      />
    );

    if (showCount) {
      const length = String(currentValue || "").length;
      const count = maxLength ? `${length} / ${maxLength}` : length;

      return (
        <div className="gm-input-show-count" style={{ display: "flex", flexDirection: "column" }}>
          {input}
          <div
            className="ant-input-textarea-show-count"
            style={{
              color: "#d9d9d9",
              textAlign: "right",
              fontSize: "14px",
              marginTop: "2px",
              fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
            }}
          >
            {count}
          </div>
        </div>
      );
    }

    return input;
  }
}
